<template>
  <div class="home">
    <div class="tableList">
      <el-menu
          :default-active="0"
          :unique-opened="true"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
      >
        <div v-for="(item,index) in tableList" :key="index">
          <el-sub-menu  v-if="item.children && item.children.length>0"  :index="index"  >
            <template #title>
              <el-icon ><component :is="item.meta.icon" /></el-icon>
              <span>{{item.meta.title}}</span>
            </template>
            <el-menu-item @click="goTo(citem)" v-for="(citem,cindex) in item.children" :index="index+'-'+cindex" :key="index+'-'+cindex">
              <div>
                <el-icon ><component :is="citem.meta.icon" /></el-icon>
                <span>{{citem.meta.title}}</span>
              </div>
            </el-menu-item>
          </el-sub-menu>
          <el-menu-item @click="goTo(item)" v-else :index="index">
            <el-icon ><component :is="item.meta.icon" /></el-icon>
            <span>{{item.meta.title}}</span>
          </el-menu-item>
        </div>

      </el-menu>
    </div>
    <UserAndImage :is-left="isLeft"></UserAndImage>
    <div class="other-view">
      <router-view></router-view>
    </div>
  </div>

</template>

<script>
import UserAndImage from "../components/UserAndImage.vue";
import {ElMenu,ElSubMenu,ElMenuItem,ElIcon} from "element-plus";
import {permission} from "../utils/storage"
export default {
  name: 'MenuTable',
  components: {
    UserAndImage,ElMenu,ElSubMenu,ElMenuItem,ElIcon
  },
  data() {
    return {
      isLeft:false,
      tabIndex:0,
      tableList: [
          {path:"/",meta:{icon:"HomeFilled",title:"首页"}},

          {
            meta:{icon:"Menu",title:"看板管理"},
            children: [
              {path:"/saleOrder",meta:{icon:"Menu",title:"销售看板"}},
            ]
          },
          {
            meta:{icon:"Van",title:"物流管理"},
            children:[
              {path:'/contrast',meta:{icon:"Menu",title:"尾程费用"} },
              {path:'/',meta:{icon:"Menu",title:"头程费用"} },
              {path:'/',meta:{icon:"Menu",title:"费用定义"} },
              {path:'/',meta:{icon:"Menu",title:"仓库管理"} },
              {path:'/',meta:{icon:"Menu",title:"物流商列表"} },
            ]
          },
          {
            meta:{icon:'Service',title:"售后管理"},
            children: [
              {path:'/',meta:{icon:"Menu",title:"未激活列"} },
              {path:'/',meta:{icon:"Menu",title:"保修激活"} },
              {path:'/',meta:{icon:"Menu",title:"售后维修"} },
              {path:'/',meta:{icon:"Menu",title:"流程定义"} },
            ]
          },
          {
            meta:{icon:'Notebook',title:"组织架构"},
            children: [
              {path:'/kMumber',meta:{icon:"Menu",title:"账号管理"} },
              {path:'/kDepartment',meta:{icon:"Menu",title:"部门管理"} },
              {path:'/',meta:{icon:"Menu",title:"菜单配置"} },
            ]
          },
          {
            meta:{icon:'Operation',title:"基础数据"},
            children: [
              {path:'/',meta:{icon:"Menu",title:"商品管理"} },
              {path:'/',meta:{icon:"Menu",title:"客户管理"} },
            ]
          },
          {
            meta:{icon:'Document',title:"数据管理"},
            children: [
              {path:'/tools',meta:{icon:"Menu",title:"API管理"} },
              {path:'/',meta:{icon:"Menu",title:"应用管理"} },
              {path:'/',meta:{icon:"Menu",title:"数据采集"} },
            ]
          },
          {path:"/tools",meta:{icon:'Setting',title:"OA流程"}}
      ],
    }
  },
  methods:{
    goTo(item){
      if (item.path =='/saleOrder') {
        this.isLeft = true;
      }else{
        this.isLeft = false;
      }
      this.$router.push({path:item.path});
    },
    handleOpen(key, keyPath){
      console.log(key, keyPath)
    },
    handleClose (key, keyPath){
      console.log(key, keyPath)
    }
  },
  beforeMount() {
    try {
      let tableList  =JSON.parse(localStorage.getItem("permission"))
      if (tableList && tableList.length > 0) {
        this.tableList = tableList
      }else{
        this.tableList  =permission
      }
    }catch(e){
      console.log(e)
    }
    let route = this.$router.currentRoute.value.path;
    if (route =='/') {
      this.isLeft = true;
    }else{
      this.isLeft = false;
    }
  }
}
</script>

<style scoped>
.home{
  position: relative;
  display: flex;
  justify-content: space-between;

}
.tableList{
  width: 200px;
  height: 100vh;
  overflow-y: auto; /* 垂直方向超出时显示滚动条 */

  /* 隐藏所有浏览器的滚动条 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 和 Edge */
}

.tableList::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

.other-view{
  width:90%;
  max-height: 100vh;
  overflow: hidden;
}
</style>